// extracted by mini-css-extract-plugin
module.exports = {"container":"main_container_3EUVG","with-loader":"main_with-loader_34L5P","flex":"main_flex_2cDXV","center":"main_center_1QYpq"};